import {config} from "@mobiusjs/homme-site-client";

config.options = require('./config.options').default

let prodConfig = {}
try {
    prodConfig = require('./config.prod').default
} catch (e) {
    console.log('No production config defined')
}

export default {
    ...config,
    version: '2.9.18',
    debug: false,
    soon: false,
    prefix: 'hom_',
    name: 'homme_site',
    title: 'Homme',
    seo: {
        title: {
            az: '',
            en: '',
            ru: ''
        },
        desc: {
            az: '',
            en: '',
            ru: ''
        }
    },
    directives: {
        connectSrc: [
            "api2.hom-me.com", "www.hom-me.com",
            "*.google.com", "stats.g.doubleclick.net",
            "www.googletagmanager.com", "www.google-analytics.com",
            "mc.yandex.ru",
            "in.hotjar.com", "vc.hotjar.io", "*.hotjar.com", "wss://*.hotjar.com",
            "*.crazyegg.com"
        ],
        defaultSrc: [
            "cdn2.hom-me.com",
            "bid.g.doubleclick.net",
            "tpc.googlesyndication.com",
            "*.crazyegg.com",
            "*.google.com",
        ],
        imgSrc: [
            "blob:", "cdn2.hom-me.com",
            "www.facebook.com", "connect.facebook.com", "connect.facebook.net",
            "img.youtube.com", "i.ytimg.com", 'www.youtube.com',
            "*.tile.osm.org",
            "www.google-analytics.com", "www.google.az", "www.google.com", "googleads.g.doubleclick.net",
            "ssl.google-analytics.com",
            "stats.g.doubleclick.net",
            "mc.yandex.ru",
            "www.googletagmanager.com",
            "ssl.gstatic.com", "www.gstatic.com", "*.googleadservices.com",
            "*.crazyegg.com",
            "*.google.com",
            "*.google.nl",
        ],
        fontSrc: [
            "data:",
            "fonts.gstatic.com",
            "script.hotjar.com"
        ],
        frameSrc: [
            "blob:", "data:",
            "www.youtube.com", "www.facebook.com", "bid.g.doubleclick.net",
            "tpc.googlesyndication.com",
            "vars.hotjar.com",
            "*.yandex.ru",
            "*.crazyegg.com",
            'app.imajin.ai',
            "td.doubleclick.net"
        ],
        scriptSrc: [
            "blob:",
            "connect.facebook.net", "*.jivosite.com",
            "www.googleadservices.com",
            "www.googletagmanager.com",
            "tpc.googlesyndication.com",
            "tagmanager.google.com",
            "www.google-analytics.com",
            "ssl.google-analytics.com",
            "www.google.com",
            "googleads.g.doubleclick.net",
            "connect.facebook.net",
            "mc.yandex.ru",
            "*.crazyegg.com"
        ],
        styleSrc: [
            "cdnjs.cloudflare.com", "*.jivosite.com",
            "tagmanager.google.com",
            "fonts.googleapis.com",
            "*.crazyegg.com"
        ]
    },
    modules: {
        library: {...config.modules.library},
        custom: {}
    },
    lang: {
        multiLang: true,
        default: 'az',
        languages: ['az', 'en', 'ru']
    },
    company: {
        established: 2020,
        title: 'Homme'
    },
    settings: {
        chooseGiftPack: false
    },
    ssl: true,
    urls: {
        api: 'api2.hom-me.com',
        cdn: 'cdn2.hom-me.com',
        site: 'www.hom-me.com'
    },
    originalSizes: [1500, 1800],
    mobile: '+994 51 207 97 72',
    chat: {
        whatsapp: "994512079772",
        messenger: "hommebaku",
        instagram: "hommebaku",
        //jivoChat: 'hVa337YhLO'
    },
    google: {
        tagManagerId: '',
        analyticsId: '',
    },
    facebook: {
        pixelId: ''
    },
    user: {
        withMobile: true,
        withOTP: true,
        withBirthday: false,
        withFacebook: true,
        withGoogle: true,
        withAppleID: false
    },
    installment: {
        active: false,
        minAmount: 50,
        cards: {
            tamkart: {
                active: false,
                title: 'TamKart',
                months: [3, 6, 12]
            },
            birkart: {
                active: false,
                title: 'BirKart',
                months: [3, 6, 12]
            }
        }
    },
    mood: {
        newYear: false
    },
    popupSecond: 15,
    pushNotification: false,
    discounts: {
        active: true
    },
    price: {
        supCent: true
    },
    ...prodConfig
}
